import { autoserialize } from 'cerialize';

export class PerreadPipeline {
  @autoserialize id!: string;
  @autoserialize batch!: string;
  @autoserialize status!: number;
}
